import { useEffect, useState } from 'react'
import LiquidGlass from 'liquid-glass-react'

const PRESETS = {
  nav: { displacementScale: 10, blurAmount: 0.08, saturation: 116, aberrationIntensity: 0.28, elasticity: 0.018 },
  tray: { displacementScale: 8, blurAmount: 0.1, saturation: 114, aberrationIntensity: 0.24, elasticity: 0.014 },
  control: { displacementScale: 7, blurAmount: 0.07, saturation: 112, aberrationIntensity: 0.2, elasticity: 0.012 },
}

function cx(...values) {
  return values.filter(Boolean).join(' ')
}

export default function LiquidGlassSurface({
  children,
  className,
  contentClassName,
  preset = 'control',
  cornerRadius = 28,
}) {
  const [reducedMotion, setReducedMotion] = useState(false)

  useEffect(() => {
    const media = window.matchMedia('(prefers-reduced-motion: reduce)')
    const update = () => setReducedMotion(media.matches)
    update()
    media.addEventListener?.('change', update)
    return () => media.removeEventListener?.('change', update)
  }, [])

  const settings = PRESETS[preset] || PRESETS.control

  return (
    <div className={cx('lg-surface', `lg-${preset}`, className)}>
      <LiquidGlass
        {...settings}
        elasticity={reducedMotion ? 0 : settings.elasticity}
        cornerRadius={cornerRadius}
        padding="0"
        mode="standard"
        className="lg-native-root"
        style={{ position: 'absolute', inset: '50% auto auto 50%', width: '100%', height: '100%' }}
      >
        <div className={cx('lg-surface-content', contentClassName)}>{children}</div>
      </LiquidGlass>
    </div>
  )
}
